export default __webpack_public_path__ + "static/media/guarda-wallet.dd4a5c19.png";